import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cart-additional-category__title"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-100 m-0" }, null, -1)
const _hoisted_3 = { class: "col-auto" }

import BranchInterface from '@/interfaces/BranchInterface';
import BaseIconButton from '@/components/BaseIconButton.vue';
import CartAdditionalCategoryCalculator from '@/components/cart/CartAdditionalCategoryCalculator.vue';
import {
  computed,
  PropType, ref,
} from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartAdditionalCategory',
  props: {
  branches: Array as PropType<BranchInterface[]>,
  branchKeys: String,
  standalone: Boolean,
  homeUrl: String,
  data: Object,
  successPage: Boolean,
},
  emits: ['update:successPage'],
  setup(__props, { emit: __emit }) {

const store = useStore();

const props = __props;

const emit = __emit;
let dataBranchKey = '';
const isSuccessPage = ref(props.successPage);

const branchesToShow = computed(() => {
  if (Array.isArray(props.branches)) {
    return props.branches;
  }

  if (Array.isArray(props?.data?.branches) && props?.data?.branches.length === 1) {
    dataBranchKey = props?.data?.branches[0] === 'strom' ? 'gas' : 'strom';
  }

  if (`${props.branchKeys || ''}`.trim() !== '' || `${dataBranchKey || ''}`.trim() !== '') {
    const branchKeys = [
      ...(props.branchKeys?.split(',') || []).map((key) => `${key}`.trim()),
      ...(dataBranchKey?.split(',') || []).map((key) => `${key}`.trim()),
    ];

    return store.getters['branches/allWithUrls'].filter((branch: BranchInterface) => branchKeys.includes(branch.slug));
  }

  return store.getters['branches/all'];
});

const selectedAdditionalBranch = ref<BranchInterface | null>(null);

const onSelectUnusedBranch = (branch: BranchInterface) => {
  if (branch.isUrl) {
    if (branch.url) window.location.href = branch.url;

    return;
  }

  selectedAdditionalBranch.value = branch;
};

const handleCancel = () => {
  if (isSuccessPage.value) {
    isSuccessPage.value = false;
    emit('update:successPage', false);
  } else {
    selectedAdditionalBranch.value = null;
  }
};

const toHomeUrl = () => {
  if (props.homeUrl) {
    window.location.href = props.homeUrl;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_BaseSpacer = _resolveComponent("BaseSpacer")!

  return (branchesToShow.value.length === 1 || __props.homeUrl)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["cart-additional-category", { standalone: __props.standalone, 'success-page': __props.data }])
      }, [
        (!__props.standalone)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Möchtest du einen weiteren Tarif dazubestellen? "))
          : _createCommentVNode("", true),
        (!__props.standalone)
          ? (_openBlock(), _createBlock(_component_BaseSpacer, { key: 1 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["row", { 'justify-content-center': __props.standalone }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(branchesToShow.value, (branch) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `category-add-button-${branch.slug}`,
              class: "col-auto"
            }, [
              _createVNode(BaseIconButton, {
                icon: branch.icon,
                "custom-icon": branch.customIcon,
                image: branch.image,
                svg: branch.svg,
                onClick: _withModifiers(($event: any) => (onSelectUnusedBranch(branch)), ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(branch.name) + " dazubestellen ", 1)
                ]),
                _: 2
              }, 1032, ["icon", "custom-icon", "image", "svg", "onClick"])
            ]))
          }), 128)),
          (__props.homeUrl)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(BaseIconButton, {
                    inverted: __props.standalone,
                    onClick: _withModifiers(toHomeUrl, ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Zurück zur Startseite ")
                    ]),
                    _: 1
                  }, 8, ["inverted"])
                ])
              ], 64))
            : _createCommentVNode("", true)
        ], 2),
        (selectedAdditionalBranch.value || isSuccessPage.value)
          ? (_openBlock(), _createBlock(CartAdditionalCategoryCalculator, {
              key: 2,
              branch: isSuccessPage.value ? branchesToShow.value[0] : selectedAdditionalBranch.value,
              address: isSuccessPage.value ? __props.data.address : _ctx.address,
              "success-page": isSuccessPage.value,
              onCancel: handleCancel
            }, null, 8, ["branch", "address", "success-page"]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})